import Layout from 'antd/es/layout';
import styled, { css } from 'styled-components';

import Button from '@components/Button';

export const StyledButton = styled(Button)<{ $alignVertical?: boolean }>`
  height: 56px !important;
  width: 200px;
  margin-left: 8px;
  ${({ $alignVertical }) =>
    $alignVertical &&
    css`
      margin: 12px 0 0 0;
      width: 100%;
    `}
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin: 12px 0;
    width: 100%;
  }
`;

export const StyledLayout = styled(Layout)<{
  isHomePage?: boolean;
}>`
  background-color: transparent;

  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    height: 100%;
  }

  ${({ isHomePage }) =>
    isHomePage &&
    css`
      margin-top: 38px;

      @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
        margin-top: 14px;
      }
    `}
`;

export const StyledContent = styled.div<{ $alignVertical?: boolean }>`
  display: flex;
  flex-direction: ${({ $alignVertical }) =>
    $alignVertical ? 'column' : 'row'};
  background-color: ${({ theme, $alignVertical }) =>
    $alignVertical ? 'transparent' : theme.palette.white};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    flex-direction: column;
    height: 100%;
  }
`;

export const DateWrapper = styled.div<{ $alignVertical?: boolean }>`
  margin: ${({ $alignVertical }) =>
    $alignVertical ? '12px 0' : '0 9px 0 12px'};
  @media ${({ theme }) => `(max-width: ${theme.breakPoint.LARGE_1X})`} {
    margin: 12px 0;
    width: 100%;
  }
`;
